import { memo } from "react";
import { useTranslation } from "react-i18next";

const LoadingIndicator = memo(({
    size = "default",
    message,
    className = "",
    variant = "primary"
}) => {
    const { t } = useTranslation();

    const sizeClasses = {
        sm: "spinner-border-sm",
        default: "",
        lg: "spinner-border-lg"
    };

    const defaultMessage = message || t("common.loading");

    return (
        <div className={`text-center py-3 ${className}`}>
            <div
                className={`spinner-border text-${variant} ${sizeClasses[size]}`}
                role="status"
                aria-hidden="true"
            >
                <span className="visually-hidden">{defaultMessage}</span>
            </div>
            {defaultMessage && (
                <p className="mt-2 mb-0 text-muted small">
                    {defaultMessage}
                </p>
            )}
        </div>
    );
});

LoadingIndicator.displayName = "LoadingIndicator";

export default LoadingIndicator;
